import { render, staticRenderFns } from "./AttributeEditor.vue?vue&type=template&id=47cca95a&scoped=true&"
import script from "./AttributeEditor.vue?vue&type=script&lang=js&"
export * from "./AttributeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cca95a",
  null
  
)

export default component.exports